/**
 * Describes the shape of a single action.
 */
export interface IPackageListingStateAction {
    type: ActionType;
    value?: any;
}

/**
 * Represents all of the actions that a user can perform on the search page. It's a class so that a dev can extend it.
 */
export class ActionType {
    
    static get UpdatePerformancesFilter() {
        return "UpdatePerformancesFilter";
    }
    
    static get RemovePerformancesFilter() {
        return "RemovePerformancesFilter";
    }
    static get RemoveAllPerformancesFilters() {
        return "RemoveAllPerformancesFilters";
    }

    static get PerformancesUpdated() {
        return "PerformancesUpdated";
    }
    
    static get BrowserNavigated() {
        return "BrowserNavigated";
    }
    
    static get LoadPackage() {
        return "LoadPackage";
    }

    static get LoadPackageRequest() {
        return "LoadPackageRequest";
    }

    static get LoadPackages() {
        return "LoadPackages";
    }

    static get UpdateSettings() {
        return "UpdateSettings";
    }

    static get SelectPerformance() {
        return "SelectPerformance";
    }

    static get AddItemToCart() {
        return "AddItemToCart";
    }

    static get RemoveItemFromCart() {
        return "RemoveItemFromCart";
    }
    
    static get UpdatePriceTypeQuantity() {
        return "UpdatePriceTypeQuantity";
    }

    static get ClearPriceTypeQuantities() {
        return "ClearPriceTypeQuantities";
    }

    static get UpdateSelectedZone() {
        return "UpdateSelectedZone";
    }

    static get RemoveSelectedZone() {
        return "RemoveSelectedZone";
    }

    static get UpdateOrderNotes() {
        return "UpdateOrderNotes";
    }

    static get UpdateSeatingPreferences() {
        return "UpdateSeatingPreferences";
    }

    static get UpdatePackageProcessing() {
        return "UpdatePackageProcessing";
    }

    static get UpdatePackageProcessingErrors() {
        return "UpdatePackageProcessingErrors";
    }

    static get RequestPerformancePricing() {
        return "RequestPerformancePricing";
    }

    static get ReceivePerformancePricing() {
        return "ReceivePerformancePricing";
    }

    static get ReceivePackagePricing() {
        return "ReceivePackagePricing";
    }

    static get ToggleMiniCart() {
        return "ToggleMiniCart";
    }

    static get InitializeCartWithSessionPerformances() {
        return "InitializeCartWithSessionPerformances";
    }
    static get UpdateGeneralAdmissionIds() {
        return "UpdateGeneralAdmissionIds";
    }

    static get LoadPwycSettings() {
        return "LoadPwycSettings";
    }

    static get UpdatePwycAmount() {
        return "UpdatePwycAmount";
    }

 //static get RequestText() {
    //    return "RequestText";
    //}
    //static get ReceiveText() {
    //    return "ReceiveText";
    //}
}